var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 96",
    style: {
      enableBackground: "new 0 0 520 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#184891;}\n\t.st1{fill:#53A1D1;}\n\t.st2{fill:#F79420;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.4,57.1c0,3.5-1.3,6.3-3.8,8.2c-2.5,2-6,2.9-10.4,2.9c-4.7,0-8.4-0.6-10.9-1.8v-4.5 c1.6,0.7,3.4,1.2,5.4,1.6c1.9,0.4,3.8,0.6,5.7,0.6c3.1,0,5.4-0.6,7-1.8c1.6-1.2,2.3-2.8,2.3-4.9c0-1.4-0.3-2.5-0.8-3.4 c-0.6-0.9-1.5-1.7-2.8-2.4c-1.3-0.7-3.3-1.6-5.9-2.5c-3.7-1.3-6.4-2.9-8-4.7c-1.6-1.8-2.4-4.2-2.4-7.1c0-3.1,1.2-5.5,3.5-7.3 c2.3-1.8,5.4-2.7,9.2-2.7c4,0,7.6,0.7,11,2.2l-1.4,4c-3.3-1.4-6.5-2.1-9.6-2.1c-2.5,0-4.4,0.5-5.8,1.6c-1.4,1.1-2.1,2.5-2.1,4.4 c0,1.4,0.3,2.5,0.8,3.4c0.5,0.9,1.4,1.7,2.6,2.4c1.2,0.7,3.1,1.6,5.6,2.4c4.2,1.5,7.1,3.1,8.6,4.8 C126.6,52.1,127.4,54.3,127.4,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156,67.7l-13.5-35.4h-0.2c0.3,2.8,0.4,6.1,0.4,10v25.4h-4.3V27.8h7L158,60.7h0.2L171,27.8h6.9v39.9h-4.6V42 c0-3,0.1-6.2,0.4-9.6h-0.2l-13.7,35.3H156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.9,67.7h-22.3V27.8h22.3v4.1h-17.6v12.9h16.6v4.1h-16.6v14.7h17.6V67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.2,31.3c-4.4,0-7.9,1.5-10.4,4.4c-2.5,2.9-3.8,6.9-3.8,12c0,5.2,1.2,9.3,3.7,12.1 c2.4,2.8,5.9,4.3,10.5,4.3c2.8,0,6-0.5,9.5-1.5v4.1c-2.8,1-6.2,1.6-10.2,1.6c-5.9,0-10.4-1.8-13.6-5.4c-3.2-3.6-4.8-8.6-4.8-15.2 c0-4.1,0.8-7.7,2.3-10.8c1.5-3.1,3.8-5.5,6.7-7.2c2.9-1.7,6.3-2.5,10.3-2.5c4.2,0,7.8,0.8,11,2.3l-2,4 C263.2,32,260.2,31.3,257.2,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.8,47.7c0,6.4-1.6,11.4-4.8,15.1c-3.2,3.7-7.7,5.5-13.5,5.5c-5.9,0-10.4-1.8-13.6-5.4 c-3.2-3.6-4.8-8.7-4.8-15.2c0-6.5,1.6-11.5,4.8-15.1c3.2-3.6,7.8-5.4,13.7-5.4c5.7,0,10.2,1.8,13.4,5.5 C311.2,36.2,312.8,41.3,312.8,47.7z M281,47.7c0,5.4,1.2,9.5,3.5,12.3c2.3,2.8,5.6,4.2,10,4.2c4.4,0,7.8-1.4,10-4.2 c2.3-2.8,3.4-6.9,3.4-12.3c0-5.4-1.1-9.4-3.4-12.2c-2.2-2.8-5.6-4.2-10-4.2c-4.4,0-7.8,1.4-10.1,4.2C282.2,38.3,281,42.3,281,47.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,67.7h-5.3l-21.8-33.5h-0.2c0.3,3.9,0.4,7.5,0.4,10.8v22.7h-4.3V27.8h5.2l21.8,33.4h0.2 c0-0.5-0.1-2.1-0.2-4.7c-0.1-2.7-0.2-4.6-0.1-5.7V27.8h4.3V67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.7,67.7h-5.3l-21.8-33.5h-0.2c0.3,3.9,0.4,7.5,0.4,10.8v22.7h-4.3V27.8h5.2l21.8,33.4h0.2 c0-0.5-0.1-2.1-0.2-4.7c-0.1-2.7-0.2-4.6-0.1-5.7V27.8h4.3V67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.7,67.7h-22.3V27.8h22.3v4.1h-17.6v12.9h16.6v4.1h-16.6v14.7h17.6V67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.5,31.3c-4.4,0-7.9,1.5-10.4,4.4c-2.5,2.9-3.8,6.9-3.8,12c0,5.2,1.2,9.3,3.7,12.1 c2.4,2.8,5.9,4.3,10.5,4.3c2.8,0,6-0.5,9.5-1.5v4.1c-2.8,1-6.2,1.6-10.2,1.6c-5.9,0-10.4-1.8-13.6-5.4c-3.2-3.6-4.8-8.6-4.8-15.2 c0-4.1,0.8-7.7,2.3-10.8c1.5-3.1,3.8-5.5,6.7-7.2c2.9-1.7,6.3-2.5,10.3-2.5c4.2,0,7.8,0.8,11,2.3l-2,4 C471.5,32,468.5,31.3,465.5,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.7,67.7h-4.6V31.9h-12.6v-4.1h29.9v4.1h-12.6V67.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.5,46 40.9,31.8 25.2,40.9 28.7,42.9 32.1,40.9 40.9,35.8 50.9,41.6 62,48 65.6,50 69.3,52.2  77.4,56.9 77.4,69.1 52.7,83.3 52.7,87.3 80.9,71.1 80.9,54.9 69,48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.4,50 29.2,57.4 40.9,64.2 56.6,55.2 56.7,55.1 53.2,53.1 49.8,55.1 40.9,60.2 19.8,48 16.4,46  4.5,39.1 4.5,27 7.9,25 29.2,12.7 29.2,8.7 1,24.9 1,41.1 12.9,48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.3,18.7 37.9,18.9 38.3,18.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,1.9l-1.7,1v15.3l-0.9,0.5l-0.4,0.2l-20.8,12l-2.1-2.8l-2.4,8l8.3,0.1l-1.8-2.5l21.7-12.5l19.8,11.5 l2.8,1.6l17.2,10v-4V28.9v-4L40.9,1.9z M77.4,38.2l-1.7-1L71,34.5L42.7,18.2V6.9L74,25l2.2,1.3l1.2,0.7V38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.9,59.7l-8.3,0l2,2.6L44.3,72.9l-3.4,2L1,51.8v3.3v0.7v11.3v3v1l39.9,23.1l1.7-1V77.8l22-12.7l2,2.6 L68.9,59.7z M39.2,89.1L4.4,69V57.8l12.1,7l22.7,13.1V89.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.8,76 28.8,79.5 31.3,81 31.3,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.5,71.2 20.5,74.8 23,76.2 23,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.2,66.4 12.2,70 14.7,71.4 14.7,67.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.1,25 67.1,28.5 69.6,29.9 69.6,26.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "58.9,20.2 58.9,23.7 61.3,25.1 61.3,21.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.6,15.4 50.6,18.9 53,20.3 53,16.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ebd9930a5133606165f70adf82600270.svg";
export { ForwardRef as ReactComponent };